export default __webpack_public_path__ + "static/media/insta2.d73aed28.jpg";